/* tslint:disable */

declare var Object: any;
export interface CategoryInterface {
  "name"?: string;
  "icon"?: string;
  "typeid"?: number;
  "createdat"?: Date;
  "updatedat"?: Date;
  "id"?: number;
}

export class Category implements CategoryInterface {
  "name": string;
  "icon": string;
  "typeid": number;
  "createdat": Date;
  "updatedat": Date;
  "id": number;
  constructor(data?: CategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Category`.
   */
  public static getModelName() {
    return "Category";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Category for dynamic purposes.
  **/
  public static factory(data: CategoryInterface): Category{
    return new Category(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Category',
      plural: 'Categories',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "icon": {
          name: 'icon',
          type: 'string'
        },
        "typeid": {
          name: 'typeid',
          type: 'number'
        },
        "createdat": {
          name: 'createdat',
          type: 'Date'
        },
        "updatedat": {
          name: 'updatedat',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/models/Category.ts